const types = {
  UPDATE_SAVED_PUBLIC_COLLEGE_SEARCH: 'UPDATE_SAVED_PUBLIC_COLLEGE_SEARCH',
  CLEAR_SAVED_PUBLIC_COLLEGE_SEARCH: 'CLEAR_SAVED_PUBLIC_COLLEGE_SEARCH',
}

export default types
